import type { ModalFuncProps } from 'antd';
import css from './index.module.scss';
import EfModal from '@/components/UI/Modal';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

interface PopupProps extends ModalFuncProps {
    visible: boolean;
    title: string;
    content?: string;
    subtitle?: string;
    richContent?: any;
    linkContent?: any;
    imgContent?: any;
    buttonText: string;
    buttonText2?: string;
    facebookUrl?: string;
    showButton?: boolean;
    btnLink: any;
    btnLink2?: any;
    btnLinkDatalayer?: any;
    width?: number;
    btnnClick?: () => void;
    handleClose?: () => void;
    maskClosable?: boolean;
    event_name?: string;
    theme?: string;
}

export default function Mm100Popup({
    visible,
    title,
    subtitle,
    content,
    richContent = null,
    linkContent = null,
    imgContent = null,
    buttonText,
    buttonText2 = '',
    onCancel,
    showButton = true,
    btnLink,
    btnLink2 = '',
    btnLinkDatalayer,
    width,
    btnnClick,
    handleClose,
    maskClosable = true,
    event_name = 'activity_join',
    theme = '',
}: PopupProps) {
    const { isMobile, useEffect, useLang, Link } = useGlobal();
    const { t } = useLang('product');
    const { t: u } = useLang(richContent?.langKey);
    const { t: linkLang } = useLang(linkContent?.langKey);
    const { EFPic } = createEFPic(imgContent?.imgUrl);

    const getDataLayer = (type = 0) => {
        return {
            event: 'uaEvent',
            event_name,
            button_name: type === 1 ? buttonText2 || t('delta2.join_community') : buttonText || t('delta2.join_community'),
        };
    };

    useEffect(() => {
        if (isMobile && visible) {
            document.documentElement.style.overflowY = 'hidden';
        }
        return () => (document.documentElement.style.overflowY = '');
    }, []);

    const handleCancel = () => {
        handleClose && handleClose();
        onCancel();
    };

    return (
        <EfModal
            visible={visible}
            onCancel={handleCancel}
            width={width || 924}
            className={`${css.popup} ${['black', '#000', '#000000'].includes(theme) ? 'black' : ''} ef-popup ${!!imgContent ? 'imgLayoutPopup' : ''}`}
            maskStyle={{ backgroundColor: 'rgba(0, 0, 0, .6)' }}
            key="ef-modal"
            maskClosable={maskClosable}
        >
            <h5 className="popup-title">{title}</h5>
            {linkContent?.langKey && linkContent?.key && (
                <div className="popup-text">
                    {linkLang.rich(linkContent?.key, {
                        JumpLink: (text: string) => (
                            <a target="_blank" className="blue" href={linkContent?.link} rel="noreferrer">
                                {text}
                            </a>
                        ),
                    })}
                </div>
            )}
            {content && <div className="popup-text">{content}</div>}
            {subtitle && <div className="popup-subtitle">{subtitle}</div>}
            {richContent?.langKey && richContent?.key && (
                <div className="popup-text">
                    {u.rich(richContent?.key, {
                        p: (text: string) => <span className="orange">{text}</span>,
                    })}
                </div>
            )}
            {showButton && btnLink && (
                <Link href={btnLink} dataLayer={btnLinkDatalayer || getDataLayer()}>
                    <button
                        className="popup-btn"
                        onClick={() => {
                            if (btnnClick) {
                                btnnClick();
                            }
                        }}
                    >
                        {buttonText || t('delta2.join_community')}
                    </button>
                </Link>
            )}
            {showButton && buttonText2 && btnLink2 && (
                <Link href={btnLink2} dataLayer={btnLinkDatalayer || getDataLayer(1)}>
                    <button className="popup-btn popup-btn2">{buttonText2 || t('delta2.join_community')}</button>
                </Link>
            )}

            {!!imgContent && (
                <div className="popup-img-box">
                    <EFPic className="popup-img" name={imgContent?.key} />
                </div>
            )}
        </EfModal>
    );
}
